export const GOOGLE_API_KEY = 'AIzaSyB-fGzLXW49C7kknClYdPWrcHDWATnCvH4';
export const SEARCH_ENGINE_ID = 'c6e341f6b616e4198';
